import React from "react";
import "./Transaction.css";
const SavestPlanDetails = ({
  title,
  amount,
  type,
  interest,
  percentage,
  active,
  duration,
}) => {
  return (
    <div className="">
      <div className="tuition-main p-3">
          <div className="mt-3">
          <p className="tuition-fees mt-4">{title}</p>
          <p className="dollar-amount">{amount}</p>
          <p className="fixed-plan">{type}</p>
        </div>
        <div className="">
          <p className="interest-amount ">{interest}</p>
          <p className="percentage-interest">{percentage}</p>
          <p className="active-class">{active}</p>
          <p className="perannum">{duration}</p>
        </div>
      </div>
    </div>
  );
};

export default SavestPlanDetails;
